import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'News Feed Comments';
moduleConfig.singleItemTitle = 'News Feed Comment';
moduleConfig.url = 'news-feed-comments';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Disabled Selected",
        value: "Disabled"
    },
    {
        displayName: "Enabled Selected",
        value: "Enabled"
    }
];


export default moduleConfig;